export enum Policies {
  SuperAdmin = "SuperAdmin",
  ViewAdminPage = "ViewAdminPage",
  ViewSearchBar = "ViewSearchBar",

  ViewCustomersList = "ViewCustomersList",
  ViewCustomerProfile = "ViewCustomerProfile",
  ViewCustomerAddressbook = "ViewCustomerAddressbook",
  ViewCustomerRoutes = "ViewCustomerRoutes",
  ViewCustomerReleases = "ViewCustomerReleases",
  ViewCustomerFulfillmentProviders = "ViewCustomerFulfillmentProviders",
  ViewCustomerContacts = "ViewCustomerContacts",
  ViewCustomerDrivers = "ViewCustomerDrivers",
  ViewCustomerUsers = "ViewCustomerUsers",
  ViewCustomerFeatures = "ViewCustomerFeatures",
  ViewCustomerNotificationOptions = "ViewCustomerNotificationOptions",

  ViewInterfaces = "ViewInterfaces",
  ViewOrders = "ViewOrders",
  ViewTrips = "ViewTrips",
  ViewPod = "ViewPod",
  ViewCustomReports = "ViewCustomReports",
  ViewTestTools = "ViewTestTools",
  ViewDeveloperSettings = "ViewDeveloperSettings",

  EditCustomerProfile = "EditCustomerProfile",
  AddOrEditCustomerAddressbook = "AddOrEditCustomerAddressbook",
  AddOrEditCustomerRoutes = "AddOrEditCustomerRoutes",
  AddOrEditCustomerReleases = "AddOrEditCustomerReleases",
  AddOrEditCustomerFulfillmentProviders = "AddOrEditCustomerFulfillmentProviders",
  AddOrEditCustomerContacts = "AddOrEditCustomerContacts",
  AddOrEditCustomerDrivers = "AddOrEditCustomerDrivers",
  AddOrEditCustomerUsers = "AddOrEditCustomerUsers",
  EditCustomerNotificationOptions = "EditCustomerNotificationOptions",
  EditCustomerFeatures = "EditCustomerFeatures",
  AddOrEditOrders = "AddOrEditOrders",
  AddOrEditTrips = "AddOrEditTrips",
  AddOrEditPod = "AddOrEditPod",
  AddOrEditCustomReports = "AddOrEditCustomReports",
  AddOrEditSchedules = "AddOrEditSchedules"
}

export type PoliciesStatus = {
  [key in Policies]: boolean;
};